import { render, staticRenderFns } from "./exhibition_notice.vue?vue&type=template&id=1a7cfe22&scoped=true&"
import script from "./exhibition_notice.vue?vue&type=script&lang=js&"
export * from "./exhibition_notice.vue?vue&type=script&lang=js&"
import style0 from "./exhibition_notice.vue?vue&type=style&index=0&id=1a7cfe22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7cfe22",
  null
  
)

export default component.exports